import { RouteLocation, RouteLocationRaw } from 'vue-router'
import PAGE_NAME from '@web/consts/PAGE_NAME'

/**
 * Редирект внешней ссылки на подписку в список подписок с id в query —
 * по нему список сам запускает нужную часть оффбординга (см.
 * computeUrlOffboarding в components.v2/Subscriptions).
 *
 * Весь query, включая token и webview, прокидывается дальше: автологин
 * по token сработает уже на /user/subscriptions (там meta.allowUrlToken),
 * а встроенный режим включится с первого экрана.
 *
 * Отдельным модулем, а не внутри router/config.ts: config при вычислении
 * создаёт history, и тесты не могут импортировать его без побочных эффектов.
 */
export function toSubscriptionsWith (idQueryKey: 'cancel_id' | 'offboarding_id') {
  return (to: RouteLocation): RouteLocationRaw => ({
    name: PAGE_NAME.SUBSCRIPTIONS,
    query: { ...to.query, [idQueryKey]: String(to.params.id) }
  })
}
